export default __webpack_public_path__ + "images/shortcut-messages.svg";